if(document.getElementById('people')){
    new Splide( '#people', {
        perPage: 4,
        gap    : '4rem',
        rewind: true,
        arrows: false,
        breakpoints: {
            '1024': {
                perPage: 4,
                gap: '4rem',
            },
            '640': {
                perPage: 2,
                gap: '1rem',
            },
            '480': {
                perPage: 1,
                gap    : '1rem',
            },
        }
    } ).mount();
};


if(document.getElementById('page-gallery')){
    new Splide( '#page-gallery', {
        perPage: 4,
        gap:     '.1rem',
        rewind: true,
        arrows: false,
        breakpoints: {
            '1024': {
                perPage: 3,
                gap:    '1rem',
            },
            '640': {
                perPage: 2,
                gap:    '1rem',
            },
            '480': {
                perPage: 1,
                gap:     '1rem',
                arrows:   false,
            },
        }
    } ).mount();
};
if(document.getElementById('rotator')){
    new Splide( '#rotator', {
        perPage: 1,
        rewind: true,
        arrows: false,
        autoplay: true,
        interval: number = 3000,
    } ).mount();
};
if(document.getElementById('news')){
    new Splide( '#news', {
        perPage: 4,
        gap    : '4rem',
        rewind: true,
        arrows: false,
        breakpoints: {
            '1024': {
                perPage: 3,
                gap: '4rem',
            },
            '640': {
                perPage: 2,
                gap: '1rem',
            },
            '480': {
                perPage: 1,
                gap    : '1rem',
            },
        }
    } ).mount();
};
if(document.getElementById('announce')){
    new Splide( '#announce', {
        perPage: 2,
        gap    : '4rem',
        rewind: true,
        arrows: false,
        breakpoints: {
            '1024': {
                perPage: 3,
                gap: '4rem',
            },
            '640': {
                perPage: 2,
                gap: '1rem',
            },
            '480': {
                perPage: 1,
                gap    : '1rem',
            },
        }
    } ).mount();
};

